import React from 'react';

import MediaTypography from 'components/MediaTypography';
import { getRoute } from '@common/constants/CampusRoutes';
import useDelayedNavigation from 'hooks/useDelayedNavigation';

import step3Src from '@common/assets/images/goals-create-step-3.webp';

import { StyledGoalsCreateStepsImg, StyledGoalsCreateStepsPaper } from '../styled';

function GoalsCreateStep3() {
	useDelayedNavigation({ path: getRoute(['REPORT', 'ABOUT', 'GOALS']) });

	return (
		<StyledGoalsCreateStepsPaper>
			<StyledGoalsCreateStepsImg
				alt="Goal create step 3"
				src={step3Src}
				sx={{ height: { sm: '290px' } }}
			/>
			<MediaTypography
				variant="h3"
				variants={{ sm: 'h4' }}
				textColor="secondary"
				sx={{ textAlign: 'center' }}
			>
				Break down step by step how you will achieve the goal
			</MediaTypography>
		</StyledGoalsCreateStepsPaper>
	);
}

export default GoalsCreateStep3;
